<template>
    <router-view />
</template>

<script>
export default {
    metaInfo() {
        return {
            title: "CTS",
        };
    },
};
</script>
